import { combineReducers } from 'redux';
import auth from './auth/auth_reducers';
import dashboard from './dashboard/dashboard_reducers';
import shipment from './shipment/shipment_reducers';
import profile from './profile/profile_reducers';
import messages from './messages/messages_reducer.jsx';
import requestAnItem from './request_an_item/request_an_item_reducer';
import postAShipment from './post_a_shipment/post_a_shipment_reducer';
import browsePackages from './browse_packages/browse_packages_reducer';
import payment from './payment/payment_reducer';
import userProfile from './user_profile/user_profile_reducer.jsx';
import addTrips from './add_trips/add_trips_reducer'


const rootReducers = combineReducers({
  auth,
  dashboard,
  shipment,
  profile,
  messages,
  requestAnItem,
  browsePackages,
  payment,
  postAShipment,
  userProfile,
  addTrips

});

module.exports = rootReducers;



// WEBPACK FOOTER //
// app/reducers.jsx